import { Flex, Link, Space, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { getAiPolicyStatus } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"
import { getEnforcementStatus } from "@/pages/GovernancePage/applications/policies/useAiPolicies.selector"

import styles from "./SummaryPolicy.module.scss"

import type { SummaryPolicyProps } from "./SummaryPolicy.types"

export const SummaryPolicy = (props: SummaryPolicyProps) => {
  const { record, showEnforcement } = props
  const { t } = useTranslation()
  const { name, count, total, overrides, type } = record
  const isAgent = type === "agent"
  const live = type === "heading" ? undefined : record.live
  const enforcement = showEnforcement && getEnforcementStatus(record)

  return (
    <Flex vertical gap={2}>
      <Flex align="center" gap={8}>
        <Text>
          AI policy set on <Link>{name}</Link>
        </Text>
      </Flex>
      {live && type !== "heading" && (
        <Space separator={<span className={styles.separator}>|</span>}>
          {record.description && (
            <Text type="secondary">
              {t("governance.ai.live.summary.platforms", {
                platforms: record.description
              })}
            </Text>
          )}
          <Text type="secondary">
            {t(
              `governance.ai.live.statuses.${getAiPolicyStatus(live).key}.label`
            )}
          </Text>
          {enforcement && (
            <Text type="secondary">
              {t(`governance.ai.enforce.status.${enforcement}`)}
            </Text>
          )}
        </Space>
      )}
      {!live && isAgent && (
        <Text type="secondary" className="sm-text-ks">
          {record.policyName}
        </Text>
      )}
      {!live && !isAgent && (
        <Space separator={<span className={styles.separator}>|</span>}>
          <Text type="secondary">
            {count} of {total} agents follow
          </Text>
          <Text type="secondary">
            {overrides} override lifts it for 1 agent
          </Text>
        </Space>
      )}
    </Flex>
  )
}
